export const PermissionCategory = Object.freeze({
  1: "Patients",
  2: "Prescriptions",
  3: "Approval",
  4: "Consultations",
  5: "Calendar",
  6: "Templates",
  7: "Analytics",
  8: "Users",
  9: "Teams",
  10:"Admin",
  11:"Documents",
  12:"Other",
  13:"Settings"
});
